import Modal from 'react-modal';
import PropTypes from 'prop-types';
import React from 'react';
import './quantityExceededModal.scss';
export default function QuantityExceededModal(_ref) {
  var isOpen = _ref.isOpen,
      onRequestClose = _ref.onRequestClose;

  /* eslint-disable quotes */
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    className: "btFlavorSelectorQtyExceeded__modal",
    overlayClassName: "btFlavorSelectorQtyExceeded__overlay"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btFlavorSelectorQtyExceeded__closeButton",
    type: "button",
    title: "close",
    onClick: onRequestClose
  }, "x"), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelectorQtyExceeded__header"
  }, "MAXIMUM QUANTITY REACHED"), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelectorQtyExceeded__message"
  }, "Decrease another flavor's quantity to add this flavor to your order.")));
}
QuantityExceededModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired
};